import React from 'react';

const BookingHeader = () => (
  <div className="text-center mb-12">
    <h1 
      className="text-4xl md:text-5xl font-bold font-serif text-brand-gold"
      style={{ 
        fontFamily: 'Cinzel, serif',
        fontWeight: '700',
        lineHeight: '1.2',
        letterSpacing: '0.025em'
      }}
    >
      Book Your Luxury Ride
    </h1>
    <p 
      className="mt-4 text-lg text-gray-300 max-w-2xl mx-auto"
      style={{ 
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '400',
        lineHeight: '1.6'
      }}
    >
      Seamless booking for your travel needs in the DMV area.
    </p>
  </div>
);

export default BookingHeader;